import { render, staticRenderFns } from "./sandbox-promotions.vue?vue&type=template&id=268db9d2&scoped=true&"
import script from "./sandbox-promotions.vue?vue&type=script&lang=tsx&"
export * from "./sandbox-promotions.vue?vue&type=script&lang=tsx&"
import style1 from "./sandbox-promotions.vue?vue&type=style&index=1&id=268db9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268db9d2",
  null
  
)

export default component.exports